import { render } from "./TasksList.vue?vue&type=template&id=d1a0e170"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"
script.render = render

export default script